import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FORGOT_PASSWORD } from '../../../constants/routes';
import { Translation, Alert, CustomLink } from '@troy/shared/src/components/common';

const useStyles = makeStyles(() => ({
  forgotLink: {
    display: 'inline'
  },
  text: {
    hyphens: 'none'
  }
}));

interface LoginErrorProps {
  className?: string;
  onClose: () => void;
}

const LoginError: React.FC<LoginErrorProps> = ({
  className,
  onClose
}): React.ReactElement => {
  const classes = useStyles();
  return (
    <Alert
      className={className}
      id="login-form-error"
      type="error"
      title="ALL_UXCOPIES_PASSWORDHELP_HEADLINE"
      onCloseClick={onClose}
    >
      <div className={classes.text}>
        <Typography component="span" variant="body2">
          <Translation keyIfNoValue isFragment>
            ALL_UXCOPIES_PASSWORDHELP_COPY1
          </Translation>
        </Typography>
        <span>&#32;</span>
        <CustomLink
          className={classes.forgotLink}
          id="login-form-error-recovery"
          variant="underline"
          to={FORGOT_PASSWORD}
          typography="body2"
        >
          <Translation keyIfNoValue isFragment>
            ALL_UXCOPIES_PASSWORDHELP_COPY2
          </Translation>
        </CustomLink>
      </div>
    </Alert>
  );
};

export default LoginError;
